<h2 style="text-align: center;">Documentation Links</h2>
<div class="row " style="display: flex;justify-content:center">
    <div>
        <li *ngFor="let link of documentationLinks">
            <a [href]="link.url" target="_blank"> {{link.filename}}</a>
        </li>
    </div>
</div>
